import get from 'lodash.get';
import React from 'react';
import { Badge } from 'react-bootstrap';

import Logo from 'src/components/Logo';

type BusinessItemProps = {
  // tslint:disable-next-line:no-any
  entity?: EntityFields;
  onClick?: () => void;
  className?: string;
  wrapperClassName?: string;
  contentClassName?: string;
  style?: React.CSSProperties;
  showBadge?: boolean;
  renderRightElements?: (business: EntityFields) => React.ReactNode;
};

const BusinessItem: React.FunctionComponent<BusinessItemProps> = ({
  entity: business,
  className,
  style,
  onClick,
  renderRightElements,
  contentClassName,
  showBadge,
}) => {
  const businessItemClasses = `d-flex c-pointer align-items-center my-2
  ${className || ''} bg-hover-light border-hover-primary`;

  return (
    <div className={`${businessItemClasses}`} style={{ minWidth: '300px', ...style }} onClick={onClick}>
      <div className="d-flex flex-fill align-items-center overflow-hidden" style={{ minWidth: '30%' }}>
        <div className="d-flex">
          <div>
            <Logo
              imageSrc={get(business, 'logo')}
              text={get(business, 'name')}
              height={40}
              width={40}
              variant="rounded-circle"
            />
          </div>
        </div>
        <div
          className={`${contentClassName ||
            ''} mx-3 py-2 m-0 d-flex flex-column justify-content-center flex-fill overflow-hidden`}
        >
          <div className="text-capitalize font-weight-bold m-0 d-flex align-items-center">
            <span className="text-truncate text-primary">{get(business, 'name') || ''}</span>
            {showBadge ? (
              <small>
                <Badge variant="warning" className="ml-2">
                  Best matched
                </Badge>
              </small>
            ) : null}
          </div>
          {business ? (
            <small className="d-block text-muted text-truncate m-0">
              {get(business, ['address', 'address1'])}, {get(business, ['address', 'city'])}
            </small>
          ) : null}
        </div>
      </div>
      {renderRightElements ? renderRightElements(business) : null}
    </div>
  );
};

export default BusinessItem;
